import { Popover, icons, themes } from '@lifebit-ai/lds'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import useUser from 'hooks/useUser'
import { ModuleIcon as ModuleIconSvg } from 'img'
import { getExportFilesListPath } from 'modules/requests/requestDetailPaths'
import Envs, { castToStringOrUseDefault } from 'utils/env'

import { ActionBtns, FooterNavItem, HelpButton, LogoContainer, NavHeader, NavbarWrapper } from './Navbar.styles'
import UserSettingsPopoverContent, { USER_SETTINGS_AVATAR_TEST_ID } from './UserSettingsPopover'
import * as UserSettingsPopoverStyles from './UserSettingsPopover.styles'

const HelpLink: React.FC = () => {
  const helpDeskUrl = castToStringOrUseDefault(
    Envs.AIRLOCK_HELPDESK_URL,
    'https://lifebit.atlassian.net/wiki/spaces/CD/pages/1132068882/As+an+Airlock+Manager'
  )

  if (!helpDeskUrl) return null

  return (
    <HelpButton
      data-testid="navbar-help-link"
      onClick={() => {
        window.open(helpDeskUrl, '_blank')
      }}
    >
      <ModuleIconSvg />
    </HelpButton>
  )
}

const Navbar: React.FC = () => {
  const navigate = useNavigate()
  const { user } = useUser()
  const userFirstChar: string = user?.user.email?.charAt(0) || '?'

  return (
    <NavbarWrapper>
      <NavHeader onClick={() => navigate(getExportFilesListPath())}>
        <LogoContainer>
          <icons.Lifebit />
        </LogoContainer>

        <span>Airlock</span>
      </NavHeader>

      <ActionBtns data-testid="popover-btn">
        <FooterNavItem>
          <HelpLink />
        </FooterNavItem>

        <FooterNavItem>
          <Popover
            color={themes.Light.color.background.main}
            content={<UserSettingsPopoverContent user={user} userFirstChar={userFirstChar} />}
            overlayInnerStyle={{ padding: '0' }}
            placement="rightTop"
            trigger="click"
          >
            <UserSettingsPopoverStyles.UserSettingsAvatar data-testid={USER_SETTINGS_AVATAR_TEST_ID}>
              {userFirstChar}
            </UserSettingsPopoverStyles.UserSettingsAvatar>
          </Popover>
        </FooterNavItem>
      </ActionBtns>
    </NavbarWrapper>
  )
}

export default Navbar
